export const roundNum = (number, decimalPlaces = 4) => {
    return parseFloat(number).toFixed(decimalPlaces);
};